require('./emitedTransfersFilters.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { getLanguage } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const { AmountFilter } = require('commonsComponents/amountFilter');
const CurrencyDropdown = require('components/transfers/currencyDropdown/currencyDropdown');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { EURO_TEXT } = require('constants/index');
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');

class EmitedTransfersFilters extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            dateSelected: immFilter.getIn(['date', 'selected']),
            dateFrom: immFilter.getIn(['date', 'from']),
            dateTo: immFilter.getIn(['date', 'to']),
            amountFrom: immFilter.getIn(['amount', 'from', 'amount']),
            amountTo: immFilter.getIn(['amount', 'to', 'amount']),
            // (andres): We need to set a default currency for emited transfers since the service
            // won't filter for an amount without a currency. We cannot implement an "all currencies" option
            currency: immFilter.getIn(['currency', 'value']) || EURO_TEXT
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    handleChangeAmountMax(amountTo) {
        this.setState({
            amountTo
        });
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({
            amountFrom
        });
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleCurrencyChange(currency) {
        this.setState({
            currency: currency.value
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const { onSetFilters, onCloseClick, accountCurrency } = this.props;
        const { dateFrom, dateTo, dateSelected, amountFrom, amountTo, currency } = this.state;
        const selectedCurrency = currency || accountCurrency;

        onSetFilters({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            amount: {
                from: {
                    currency: selectedCurrency,
                    amount: amountFrom
                },
                to: {
                    currency: selectedCurrency,
                    amount: amountTo
                }
            },
            currency: {
                value: selectedCurrency
            }
        });

        onCloseClick();
    }

    render() {
        const { accountCurrency, immFilter, isOpen, onCloseClick } = this.props;
        const { amountFrom, amountTo, currency } = this.state;
        const selectedCurrency = currency || accountCurrency;

        const content = (
            <section className="emited-transfers-filters">
                <fieldset>
                    <DateFilter
                        immFilter={immFilter.get('date')}
                        onChangeMin={this.handleChangeDateMin}
                        onChangeMax={this.handleChangeDateMax}
                        onChangeSelected={this.handleChangeDateSelected}
                    />
                </fieldset>
                <fieldset>
                    <AmountFilter
                        immFilter={immFilter}
                        onChangeMin={this.handleChangeAmountMin}
                        onChangeMax={this.handleChangeAmountMax}
                        fromValue={amountFrom}
                        toValue={amountTo}
                        currencySymbol={formatCurrency(selectedCurrency)}
                        amountLabel={AMOUNT_FILTER_LABEL}
                        greaterThan={AMOUNT_FILTER_GREATER_THAN}
                        lowerThan={AMOUNT_FILTER_LOWER_THAN}
                        language={getLanguage()}
                    />
                </fieldset>
                <fieldset>
                    <CurrencyDropdown
                        value={currency}
                        onChange={this.handleCurrencyChange}
                        openUp={true}
                    />
                </fieldset>
            </section>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="transfersEmited-apply"
                secondaryButtonText="transfersEmited-cancel"
                title="transfersEmited-filterEmitedTransfers"
                type="filter"
            />
        );
    }
}

EmitedTransfersFilters.propTypes = {
    accountCurrency: PropTypes.string,
    immFilter: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
}

EmitedTransfersFilters.defaultProps = {
    accountCurrency: EURO_TEXT
}

module.exports = EmitedTransfersFilters;
